<template>
  <!-- Section START-->
  <section class="py-5 bg-light mb-0">
    <div class="container px-5 my-5">
      <div class="row gx-5 align-items-center">
        <div class="col-xxl-4 d-none d-xxl-block" data-aos="fade-up" data-aos-delay="200"><img class="img-fluid rounded mb-5 mb-lg-0" src="@/assets/img/mic.gif" alt="..." /></div>
        <div class="col-xxl-8">
          <h2 class="mb-5 text-center" data-aos="fade-up" data-aos-delay="200">Diesen Service bekommt Ihr von mir</h2>

          <div class="row g-5 pt-3">

            <!-- Items -->
            <div v-for="(service, index) in services" :key="index" class="col-12 col-md-6" data-aos="fade-up" data-aos-delay="200">
            <div class="border-1 border border-dark px-3 pb-3 rounded-2 h-100 bg-white">
                <div class="bg-dark text-white p-3 rounded-circle feature">
                  <i :class="'bi bi-' + service.icon + ' fs-4'"></i>
                </div>
                <p class="mt-3">{{ service.text }}</p>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  </section>
  <!-- Section END-->
</template>

<script setup>
const services = [
  {
    'icon': 'telephone',
    'text': 'Kostenloses und ausführliches Vorgespräch - am Telefon oder persönlich.'
  },
  {
    'icon': 'piggy-bank',
    'text': 'Faire Preise.'
  },
  {
    'icon': 'person-check',
    'text': 'Langjährige Erfahrung, freundliches Auftreten und professionelle Vorbereitung.'
  },
  {
    'icon': 'music-note-beamed',
    'text': 'Top-aktuelle Musiksammlung. Musikauswahl/-wünsche im Vorgespräch und beim Event.'
  },
  {
    'icon': 'camera',
    'text': 'Hochwertige Premium-Fotobox, High End Equipment & Premium-Licht- und Tontechnik.'
  },
  {
    'icon': 'hand-thumbs-up',
    'text': 'Individuell und flexibel. Ersatz-DJ bei Ausfall'
  },
  {
    'icon': 'chat-dots',
    'text': 'Finales Gespräch kurz vor der Hochzeit.'
  },
  {
    'icon': 'person-lines-fill',
    'text': 'Kontakt mit Trauzeugen und anderen Hochzeitsdiensleistern.'
  }
]
</script>

<style scoped>
.feature {
  margin-top: -1rem;
}
</style>